<template>
  <div class="bbe-select-tags" @click.stop>
    <div class="bbe-select-tags-header">
      <label class="bbe-select-tags-header-label">
        <input class="bbe-input bbe-input_border bbe-select-tags-header-label__input"
               :class="{'bbe-input_border_error': errorInput}"
               @keyup.enter="createTag"
               @keyup.esc="closeSelect"
               v-autofocus
               @click="errorInput = false"
               v-model="tagSearch"
               placeholder="Hashtag"
               type="text"/>
        <transition name="bbe-routing-fade">
          <span class="bbe-label bbe-label__error bbe-select-tags-header-label__error" v-if="errorInput">
            {{errorInput}}
          </span>
        </transition>
        <i class="email-icon-hashtag bbe-select-tags-header-label__icon"/>
      </label>
      <button class="bbe-select-tags-header-button" @click="createTag">Add tag</button>
    </div>
    <VuePerfectScrollbar class="bbe-select-tags-list" :settings="{wheelPropagation: false}">
      <transition-group tag="div" name="bbe-list-complete">
        <div class="bbe-select-tags-list__tag"
             v-for="tag in filterTagList"
             :key="tag.id"
             @click="setTag(tag)">
          #{{ tag.name }}
        </div>
      </transition-group>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import tagsApi from '@/api/Tags/api'
import userEmailsApi from '@/api/UserEmails/api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {get, orderBy} from 'lodash'

export default {
  name: 'SelectTags',
  props: ['thread'],
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      tagSearch: '',
      errorInput: '',
      userMail: {}
    }
  },
  computed: {
    filterTagList () {
      const tagsFilters = this.tagList.filter(item => !this.setTagsIds.includes(item.id))
      if (this.tagSearch) {
        const regForFilter = new RegExp(this.tagSearch, 'gmi')
        const result = tagsFilters.filter(tag => {
          regForFilter.lastIndex = 0
          return regForFilter.test(tag.name)
        })
        const regForSort = new RegExp('^' + this.tagSearch, 'gmi')
        return result.sort((a, b) => {
          regForSort.lastIndex = 0
          return regForSort.test(b.name) - regForSort.test(a.name)
        })
      }
      return tagsFilters
    },
    setTagsIds () {
      const tags = get(this.thread, 'tags', [])
      return tags.map(tag => tag.id)
    },
    tagList: {
      get: function () {
        return this.$store.getters.tagList
      },
      set: function (data) {
        this.$store.dispatch('setTagList', data)
      }
    }
  },
  methods: {
    setTag (tag) {
      const tags = get(this.thread, 'tags', [])
      tags.push(tag)
      const id = get(this.userMail, 'id', '')
      const threadId = get(this.thread, 'id', '')
      const body = {
        tags: tags.map(tag => tag.id),
        googleId: threadId
      }
      if (id) body.id = id
      id ? userEmailsApi.updateUserEmails(body) : userEmailsApi.createUserEmails(body)
    },
    createTag () {
      if (!this.tagSearch) {
        this.errorInput = 'can\'t be blank'
        return
      }
      tagsApi.createTag({name: this.tagSearch, typeTag: 'custom'})
        .then(resp => {
          this.tagSearch = ''
          this.tagList.push(resp.data)
          this.tagList = orderBy(this.tagList, [item => item.name.toLowerCase()], ['asc'])
          this.setTag(resp.data)
        })
        .catch(err => {
          console.error(err)
        })
    },
    getUserMail () {
      const threadId = get(this.thread, 'id', '')
      userEmailsApi.getUserEmails({threadId: threadId, limit: 1})
        .then(resp => {
          this.userMail = get(resp, ['data', 'useremails', 0], {})
        })
        .catch(err => {
          console.error(err)
        })
    },
    getTagList () {
      tagsApi.getTags({})
        .then(resp => {
          this.tagList = orderBy(resp.data.tags, [item => item.name.toLowerCase()], ['asc'])
        })
        .catch(err => {
          console.error(err)
        })
    },
    closeSelect () {
      this.$emit('close')
    }
  },
  beforeMount () {
    this.getUserMail()
    if (this.tagList.length === 0) this.getTagList()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-select-tags {
  background: $color-white;
  box-shadow: 0 0 15px rgba($color-black, 0.08);
  border-radius: 4px;
  width: 229px;

  &-header {
    position: relative;
    padding: 12px 12px 16px;
    border-bottom: 1px solid $color-wild-sand;
    cursor: default;

    &:after {
      content: '';
      position: absolute;
      top: -5px;
      right: 9px;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 0 5px 5px 5px;
      border-color: transparent transparent $color-white transparent;
    }

    &-label {
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      &__icon {
        position: absolute;
        left: 10px;
        top: auto;
        font-size: 10px;
        color: $color-silver-chalice;
        transition: 0.3s;
      }

      &__input {
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        padding-left: 26px;

        &:focus + i {
          color: $color-accent;
        }
      }

      &__error {
        right: 10px;
        pointer-events: none;
      }
    }

    &-button {
      display: block;
      margin-left: auto;
      margin-right: 0;
      color: $color-accent;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        color: $color-accent-hover;
      }
    }
  }

  &-list {
    max-height: 208px;
    margin: 12px 0;
    overflow: hidden;

    &__tag {
      font-weight: 500;
      font-size: 13px;
      line-height: 16px;
      color: $color-black;
      padding: 9px 12px;
      transition: 0.3s;

      &:hover {
        background-color: $color-wild-sand;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/SelectTags/SelectTags.vue